import { render } from "./AppFooter.vue?vue&type=template&id=5231fad2&ts=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lk/Documents/SecondCorner/programs/sc_backend_v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__